import React from 'react';
import LazyLoad from 'react-lazyload';
import './PartnerCaroussel.css';

function PartnerCaroussel() {
  const partnerImages = [
    'Shell-logo.jpg',
    'marino.jpg',
    'TotalEnergies-Nouveau-Logo.jpg',
    'steg.png',
    'ecm.jpg',
    'sncpa.jpg',
    'omv.jpg',
    'meri.jpg',
    'socomenin.jpg',
    'etap.jpg',
    'boucahmeoui.jpg',
    'colas-rail.jpg',
    'nesteoil.jpg',
    'metec.jpg',
    'petrofac.jpg',
    'pionner.jpg',
    'sarost.jpg',
    'serpet.jpg',
    'ciments-de-bizete.jpg',
    'daewooec.jpg',
  ];

  const imageDimensions = {
    height: 100, // Modify the desired height
    width: 130, // Modify the desired width
  };

  return (
    <div className="slider">
      <div className="slide-track">
        {partnerImages.map((image, index) => (
          <LazyLoad key={index} height={imageDimensions.height} offset={100}>
            <div className="slide" key={index}>
              <img
                src={`images/${image}`}
                alt={`Partner ${index + 1}`}
                height={imageDimensions.height}
                width={imageDimensions.width}
              />
            </div>
          </LazyLoad>
        ))}
      </div>
    </div>
  );
}

export default React.memo(PartnerCaroussel);